import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=7a1aa49e&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=7a1aa49e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1aa49e",
  null
  
)

export default component.exports